var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.67,12h0A14,14,0,0,0,2.33,12a1.18,1.18,0,0,0-.33.81,1.06,1.06,0,0,0,.33.8l2,2a1.15,1.15,0,0,0,.8.34,1.13,1.13,0,0,0,.8-.32A9.19,9.19,0,0,1,8,14.14a1.11,1.11,0,0,0,.64-1V10.87A11.51,11.51,0,0,1,12,10.38h0a11.32,11.32,0,0,1,3.32.5v2.25a1.16,1.16,0,0,0,.64,1,8.69,8.69,0,0,1,2.07,1.43,1.16,1.16,0,0,0,.79.32h0a1.14,1.14,0,0,0,.81-.34l2-2A1.16,1.16,0,0,0,21.67,12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/end-call.8937f1eef54f4d77827e258a451bd66e.svg";
export { ForwardRef as ReactComponent };